<template>
<div class="content2">
  <div class="header">
    <el-select size="mini" placeholder="统计类型" clearable v-model="where2.leave">
      <el-option value="" label="全部"></el-option>
<!--      <el-option :value="2" label="战区小计"></el-option>-->
<!--      <el-option :value="4" label="项目小计"></el-option>-->
      <el-option :value="5" label="项目经理"></el-option>
      <el-option :value="6" label="管家主任"></el-option>
    </el-select>
    <el-select size="mini" placeholder="排序方式" clearable v-model="where2.order_by">
      <el-option value="task_finish_rate DESC" label="任务完成率[排序]"></el-option>
      <el-option value="hk_rate DESC" label="催回效率[排序]"></el-option>
      <el-option value="urge_rate DESC" label="回款率[排序]"></el-option>
    </el-select>

    <el-button @click="exportExcel">导出报表</el-button>
  </div>
  <div class="body">
    <div class="table-wrap">
      <el-table
        v-loading="loading"
        :span-method="objectSpanMethod"
        :data="tableData"
        border height="60vh">
        <el-table-column label="名称" prop="name" align="center" min-width="180" fixed></el-table-column>
        <el-table-column label="催费标准" prop="plan_count" align="center" min-width="120"></el-table-column>
        <el-table-column label="实际催费" align="center">
          <el-table-column label="户数" prop="actual_count" align="center" min-width="120" :formatter="intMilFormatter"></el-table-column>
          <el-table-column label="金额" prop="actual_amount" align="center" min-width="120" :formatter="milFormatter"></el-table-column>
        </el-table-column>
        <el-table-column label="实际回款" align="center">
          <el-table-column label="户数" prop="hk_count" align="center" min-width="120" :formatter="intMilFormatter"></el-table-column>
          <el-table-column label="金额" prop="hk_amount" align="center" min-width="120" :formatter="milFormatter"></el-table-column>
        </el-table-column>
        <el-table-column label="任务完成率" prop="task_finish_rate2" align="center" min-width="120">
          <template slot-scope="scope">
            {{toFixed(scope.row.task_finish_rate2,2)}}%
          </template>
        </el-table-column>
        <el-table-column label="催回效率" prop="hk_rate2" align="center" min-width="120">
          <template slot-scope="scope">
            {{toFixed(scope.row.hk_rate2,2)}}%
          </template>
        </el-table-column>
        <el-table-column label="回款率" prop="urge_rate2" align="center" min-width="120">
          <template slot-scope="scope">
            {{toFixed(scope.row.urge_rate2,2)}}%
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</div>
</template>

<script>
import {CommonHelp} from "../../common/CommonHelp";
import ButlerHttp from "../../common/ButlerHttp";
import moment from "moment";

export default {
  name: "StatisticalTableOfCollectionForce",
  inject:['where','reginWhere'],
  props:{
    age_type:{
      type:Array,
      default:()=>[]
    }
  },
  data() {
    return{
      where2:{
        year_month:moment().format("YYYY-MM"),
        leave:"",
        order_by:"",
      },
      loading:false,
      tableData:[]
    }
  },
  mounted() {
    const that=this;
    this.pageChange(1);
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_ids":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where.start_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where.end_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.leave":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.order_by":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
  },
  methods: {
    getList(){
      const that = this;
      that.loading = true;
      let where = {
        ...that.where2,
        start_date:that.where.start_time,
        end_date:that.where.end_time,
        region_id:that.reginWhere.project_region,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
        age_type: that.age_type.join(',')
      }
      if(that.reginWhere.project_region_level) where.region_level=that.reginWhere.project_region_level;
      where.level=that.getLevel();

      ButlerHttp.post("ProjectCollectionUrgePayment/index2",{
        ...where,
      }, res => {
        if (res.code) {
          that.tableData = res.data
        }
        that.loading = false;
      })
    },
    pageChange(i) {
      const that=this;
      CommonHelp.debounce(()=>{
        that.getList()
      },500,that);

    },
    getLevel(){
      const that = this;
      let level=0;
      if(that.reginWhere.area_id){
        level=5;
      }else if(that.reginWhere.project_name){
        level=4;
      }else if(that.reginWhere.project_region){
        if(that.reginWhere.project_region_level===1){
          level=2;
        }else if(that.reginWhere.project_region_level===2){
          level=3;
        }
      }else {
        level=1;
      }
      return level;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const prevRow = this.tableData[rowIndex - 1];
        const currRow = row;

        if (prevRow && prevRow[column.property] === currRow[column.property]) {
          return { rowspan: 0, colspan: 0 };
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i][column.property] === currRow[column.property]) {
              rowspan++;
            } else {
              break;
            }
          }
          if (rowspan > 1) {
            return { rowspan: rowspan, colspan: 1 };
          }
        }
      }
    },
    exportExcel(){
      const that=this;
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        ...that.where2,
        start_date:that.where.start_time,
        end_date:that.where.end_time,
        region_id:that.reginWhere.project_region,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
        age_type: that.age_type.join(',')
      }
      if(that.reginWhere.project_region_level) where.region_level=that.reginWhere.project_region_level;
      where.level=that.getLevel();
      ButlerHttp.post("StatisticalTable/ProjectCollectionUrgePaymentExcel",{
        ...where,
      },res => {
        loading.close()
        if (res.code===1) {
          window.open(res.data)
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    toFixed(num,n){
      return Math.round(num*Math.pow(10,n))/Math.pow(10,n);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
.content2{
  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: flex;
    flex-direction: row;

    .header-tip-body{
      //width: 500px;
      margin-left: 50px;
      display: flex;
      flex-direction: row;
      //justify-content: space-between;
      .header-tip-body-item{
        margin-left: 50px;
        display: flex;
        flex-direction: row;
      }
    }
  }
  .pagination-wrap{
    margin-top: 10px;
    text-align: center;
  }

  >>>.el-table--border, .el-table--group{
    border: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
    border-bottom: 1px solid #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/report_forms/StatisticalTableOfCollectionForce.vue